import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading font-bold text-lg">
                911
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                黑料网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              专注独家爆料、真实内幕揭秘的内容聚合平台。为你呈现最真实、最劲爆的幕后故事。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="Telegram">
                <i className="ri-telegram-line text-background-300 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4">
              <a href="/" className="hover:text-background-200 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4">
              <a href="/about" className="hover:text-background-200 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">读者口碑</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">联系我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">加入我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-background-500"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-shield-check-line mt-0.5 text-background-500"></i>
                <span>匿名举报通道</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-scales-line mt-0.5 text-background-500"></i>
                <span>法律声明</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {siteInfo.foundedYear} - {new Date().getFullYear()} 911黑料网 版权所有 | 本站内容仅供信息参考，不构成任何建议
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}